import { render } from "./checkmark.svg?vue&type=template&id=361d162a"
const script = {}
script.render = render

export default script